import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import config from "lib/config"
import { TRACKING_EVENTS } from "lopermut"
import mixpanel from "mixpanel-browser"

export const useSignupByWebsiteMutation = () => {
  return useMutation({
    mutationFn: async ({
      email,
      phone,
      locale,
    }: {
      email: string
      phone: string
      locale: string
    }) => {
      const { data } = await axios.post("/auth/signup-website", { email, phone, locale })
      return data.data as { success: boolean }
    },
    onSuccess: (_data, { email }) => {
      if (!config.isProduction) return
      mixpanel.track(TRACKING_EVENTS.SIGNUP_WEBSITE_SUCCESS, { email })
    },
    onError: (_error, { email }) => {
      if (!config.isProduction) return
      mixpanel.track(TRACKING_EVENTS.SIGNUP_WEBSITE_ERROR, { email })
    },
  })
}
